import { Card, Col, Form, Row, Button, message, Input } from 'antd'
import React, { useState, useEffect } from 'react'
import { KeywordsComp } from '../ChatBot/ChatbotCodeComps/ChatbotFields'
import { ROW_GUTTER } from 'constants/ThemeConstant'
import { UserSelectField } from '../CustomUtils.js/CommonFieldUtils'
import apiClient from 'services/apiClient'

const { TextArea } = Input;

const BlockedKeywords = ({ UserData, userRole, api }) => {
    const [loading, setLoading] = useState(false)
    const [user, setUser] = useState(null)
    const [inputValue, setInputValue] = useState('')
    const [badges, setBadges] = useState([])
    const [successMessage, setSuccessMessage] = useState('You Have Successfully Unsubscribed From This Number')

    // Set user based on role when component mounts
    useEffect(() => {
        if (userRole !== 'Admin') {
            setUser(UserData?.id);
        }
    }, [UserData, userRole]);

    const handleSubmit = async () => {
        setLoading(true)
        try {
            const formData = new FormData();
            formData.append('user_id', user);
            formData.append('chatbot_type', 'Custom');
            formData.append('custom_message_type', 'text');
            formData.append('custom_type', 'Url');
            formData.append('external_url', `https://sndwb.smsforyou.biz/api/block-number?number=#number&user_id=${user}`);
            formData.append('url_action_type', 'Json');
            // json_true_key
            formData.append('json_true_key', 'status');
            // json_true_value
            formData.append('json_true_value', 'true');
            formData.append('json_true_outgoing_res', 'Text');
            formData.append('json_true_custom_text', successMessage);
            formData.append('keyword', badges.join(',')); // Join the array into a string

            if (Array.isArray(badges)) {
                badges?.forEach((badge) => {
                    formData.append('keyword[]', badge);
                });
            }

            const config = {}

            const response = await apiClient.post(`${api}chatbot-create`, formData, config)

            if (response.data) {
                message.success('Keywords blocked successfully')
                // Reset form after successful submission
                setBadges([])
                setInputValue('')
                setUser(null)
            } else {
                message.error(response.data.message || 'Failed to block keywords')
            }
        } catch (error) {
            console.error('API Error:', error)
            message.error('An error occurred while blocking keywords')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Card title="Blocked Numbers - Via Keyword">
            <Row gutter={ROW_GUTTER}>
                {userRole === 'Admin' ? (
                    <Col xs={24} md={12} lg={24}>
                        <Form.Item label="Select User" name="user" className="mb-0">
                            <UserSelectField
                                value={user}
                                HandleUserChange={setUser}
                            />
                        </Form.Item>
                    </Col>
                ) : null}
                <Col xs={24} md={12} lg={24}>
                    <KeywordsComp
                        badges={badges}
                        setBadges={setBadges}
                        inputValue={inputValue}
                        setInputValue={setInputValue}
                    />
                </Col>
                <Col xs={24} md={12} lg={24} className="mt-3">
                    <Form.Item label="Success Message" className="mb-0">
                        <TextArea
                            rows={3}
                            value={successMessage}
                            onChange={(e) => setSuccessMessage(e.target.value)}
                            placeholder="Enter message to display when number is blocked"
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} className="mt-3 text-center">
                    <Button
                        type="primary"
                        onClick={handleSubmit}
                        loading={loading}
                        disabled={!user || badges.length === 0}
                    >
                        Submit
                    </Button>
                </Col>
            </Row>
        </Card>
    )
}

export default BlockedKeywords
